// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getObjectKeys = <F extends Record<string, any>>(obj: F): Extract<keyof F, string>[] => {
  return Object.keys(obj) as Extract<keyof F, string>[];
};
